import { ArrowRightIcon } from 'lucide-react'
import { useEffect } from 'react'
import { toast } from 'sonner'

import { EmployerOnboardingPage, useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { CenteredLayout } from 'pages/employer_onboarding/CenteredLayout'
import { Button, Switch, usePageTitle } from 'slab'
import { usePostPayrollManageAutomatedDeductions as useUpdateAutomaticDeductions } from 'utils/web_api'

import { usePayrollConfig } from '../PayrollConfigProvider'

export function AutomaticDeductionsPage () {
  usePageTitle('Automate your payroll deductions')

  const { payrollConfig, refetch: refetchPayrollConfig } = usePayrollConfig()
  const { navigateToPreviousStep, navigateToStep, navigateToNextStep } = useOnboardingStep()

  const updateAutomaticDeductions = useUpdateAutomaticDeductions({
    mutation: {
      onSuccess: () => {
        refetchPayrollConfig()
      },
      onError: () => {
        toast.error('Could not update automatic deductions because of an error')
      }
    }
  })

  useEffect(() => {
    if (
      !payrollConfig?.connected_to_payroll ||
      !payrollConfig?.supports_automatic_payroll_deductions
    ) {
      navigateToStep(EmployerOnboardingPage.PAYROLL)
    }
  }, [
    payrollConfig?.connected_to_payroll,
    payrollConfig?.supports_automatic_payroll_deductions,
  ])

  const enabled = !!payrollConfig?.has_automatic_payroll_deductions

  return (
    <CenteredLayout displaySupportLink>
      <CenteredLayout.Header
        heading='Automate your payroll deductions'
        subheading='Your employees will pay their portion of health plan costs through regular deductions from their paychecks.'
      />
      <CenteredLayout.Container>
        <Switch
          label='Automate my payroll deductions'
          description='You can opt out anytime to manage deductions manually'
          checked={enabled}
          onChange={() => {
            updateAutomaticDeductions.mutate({
              data: {
                enabled: !enabled,
              },
            })
          }}
        />
        <hr />
        {enabled
          ? (
            <div>
              <p className='mb-2'>
                Thatch can automatically submit these deductions to your payroll
                system.
              </p>
              <p className='text-gray-500'>
                We'll notify you every time we make a change to deductions.
              </p>
            </div>
            )
          : (
            <div>
              <p>
                Thatch will not automatically submit these deductions to your
                payroll system.
              </p>
            </div>
            )}
      </CenteredLayout.Container>
      <CenteredLayout.Buttons>
        <Button
          variant='secondary' onClick={navigateToPreviousStep}
        >
          Back
        </Button>
        <Button
          variant='primary'
          rightIcon={ArrowRightIcon}
          onClick={navigateToNextStep}
        >
          Next
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
